export enum VideoActions {
	PLAY = "PLAY",
	PAUSE = "PAUSE",
	MUTE = "MUTE",
	UNMUTE = "UNMUTE",
	TIME_CHANGED = "TIME_CHANGED",
	DURATION_CHANGED = "DURATION_CHANGED",
	ENDED = "ENDED"
}
